<div class="scene-player-controls">

  <button
    mat-icon-button
    class="control-button"
    [disabled]="!hasPrevious"
    (click)="onPrev.emit()"
    matTooltip="Jugada anterior">
    <mat-icon>skip_previous</mat-icon>
  </button>

  <div class="scene-info-box">
    <span class="label">Jugada</span>
    <span class="value">{{ currentIndex + 1 }} / {{ totalScenes }}</span>
  </div>

  <button
    mat-icon-button
    class="control-button"
    [disabled]="!hasNext"
    (click)="onNext.emit()"
    matTooltip="Siguiente jugada">
    <mat-icon>skip_next</mat-icon>
  </button>

  <div class="divider"></div>

  <button
    mat-icon-button
    class="control-button"
    (click)="onReplay.emit()"
    matTooltip="Reiniciar jugada actual">
    <mat-icon>replay</mat-icon>
  </button>

  <button
    mat-icon-button
    class="control-button"
    [disabled]="!canRewind5s"
    (click)="onRewind5s.emit()"
    matTooltip="Últimos 5 segundos">
    <mat-icon>replay_5</mat-icon>
  </button>

</div>
